export default __webpack_public_path__ + "static/icp-acc-logo-f3a5654798f42fb50eaa9fd804f5d813.png";